export interface NavigationUserLike {
  role?: string | null;
  roleName?: string | null;
  siteCode?: string | null;
  tenant?: string | null;
  companyId?: string | number | null;
}

const normalize = (value?: string | null): string => {
  const text = String(value || '').trim();
  if (!text) return '';
  if (['null', 'undefined', 'none', 'nan'].includes(text.toLowerCase())) return '';
  return text.toUpperCase();
};

export const resolveActiveSiteCode = (input?: {
  routeSite?: string | null;
  propSite?: string | null;
  userSiteCode?: string | null;
  userTenant?: string | null;
  preferStoredContext?: boolean;
}): string => {
  const routeSite = normalize(input?.routeSite);
  const propSite = normalize(input?.propSite);
  const userSiteCode = normalize(input?.userSiteCode);
  const userTenant = normalize(input?.userTenant);

  const storedSession = normalize(sessionStorage.getItem('tenant'));
  const storedLocal = normalize(localStorage.getItem('currentSite'));

  if (routeSite) return routeSite;

  // Prefer explicit site context selected by user (session/local) for admin navigation.
  if (input?.preferStoredContext !== false) {
    if (storedSession) return storedSession;
    if (storedLocal) return storedLocal;
  }

  if (propSite) return propSite;
  if (userSiteCode) return userSiteCode;
  if (userTenant) return userTenant;

  return '';
};

export const getRoleName = (user?: NavigationUserLike | null): string => {
  return String(user?.roleName || user?.role || '').trim().toLowerCase().replace(' ', '_');
};

export const buildHomeNavigationTarget = (input?: {
  user?: NavigationUserLike | null;
  isGlobalAdmin?: boolean;
  siteCode?: string | null;
}): string => {
  const roleName = getRoleName(input?.user);
  const isGlobalAdmin = !!input?.isGlobalAdmin || ['system_admin', 'super_admin'].includes(roleName);
  const isHoAdmin = ['ho_admin', 'company_admin'].includes(roleName);
  const siteCode = normalize(input?.siteCode);

  // Global admins should always re-enter tenant context via company selection.
  // This avoids stale local/session site values (e.g., AXON001) forcing wrong navigation.
  if (isGlobalAdmin) {
    return '/select-company';
  }

  if (siteCode) {
    return `/dashboard/${siteCode}`;
  }

  if (isHoAdmin) {
    const companyId =
      input?.user?.companyId ||
      sessionStorage.getItem('company_id') ||
      localStorage.getItem('company_id');

    if (companyId) {
      return `/select-site?company_id=${encodeURIComponent(String(companyId))}`;
    }
    return '/select-site';
  }

  return '/select-site';
};
